export default __webpack_public_path__ + "static/media/main_level_test03_jp.45bd9058.png";